<div class="search-text">
  <input style="background: #f3f5fd; border-radius: 15px; width: 240px; margin-top: 10px; margin-left: 10px; height: 25px; padding: 5px;" matInput (keyup.enter)="filtrarObjetivo($event.target.value)"
    [matTooltip]="'Ingrese el texto a buscar, luego presione la tecla Enter'" placeholder="Buscar">
</div>

<mat-tree [dataSource]="dataSource" [treeControl]="treeControl">

  <mat-tree-node [ngStyle]="{'background-color':(node.id==nodoSeleccionado.id && node.nombre == nodoSeleccionado.nombre?'#e4d9dd':'#e6e9ee')}" matTreeNodePadding matTreeNodePaddingIndent="15" *matTreeNodeDef="let node" matTreeNodeToggle>
    <div class="custom-mat-tree" (click)="irNivelSeleccionado(node)">
      <div style="display: inline-flex; width: 100%; margin: 5px;">
        <div style="float: left; width: calc(100% - 5px);">
          <ng-template [ngIf]="node.configuracionPlan">
            <div [matTooltip]="node.configuracionPlan.nivel == 1 ? node.descripcion: ''">{{node.nombre}}
            </div>
          </ng-template>
          <div style="display:block;" *ngIf="!node.configuracionPlan || node.configuracionPlan.nivel != 1">
            {{node.descripcion}}
          </div>
        </div>
        <div style="float:right;width: 10px;">
          <div class="semaforo-objetivo" [ngClass]="{'verde':node.avance>(+this.sharedService.limiteAmbar),'ambar':(node.avance>(+this.sharedService.limiteRojo)&&node.avance<(+this.sharedService.limiteAmbar+1)),'rojo' :node.avance<(+this.sharedService.limiteRojo+1) }"></div>
        </div>
      </div>
    </div>
  </mat-tree-node>

  <mat-tree-node [ngStyle]="{'background-color':(node.id==nodoSeleccionado.id && node.nombre == nodoSeleccionado.nombre?'#e4d9dd':'#e6e9ee')}" matTreeNodePadding matTreeNodePaddingIndent="15" *matTreeNodeDef="let node; when: hasChild">
    <div class="custom-mat-tree" (click)="irNivelSeleccionado(node)" mat-icon-button matTreeNodeToggle>
      <div style="display: inline-flex; width: 100%; margin: 5px;">
        <div style="float: left;width: calc(100% - 5px);">
          <ng-template [ngIf]="node.configuracionPlan">
            <div [matTooltip]="node.configuracionPlan.nivel == 1 ? node.descripcion: ''">
              <i style="color: #191a1f; padding-right: 2px;" class="fas" [ngClass]="{'fa-minus':node.expanded, 'fa-plus':!node.expanded}"></i>
              {{node.nombre}}
            </div>
          </ng-template>
          <div style="display:block;" *ngIf="!node.configuracionPlan || node.configuracionPlan.nivel != 1">
            {{node.descripcion}}
          </div>
        </div>
        <div style="float:right;width: 10px;">
          <div class="semaforo-objetivo" [ngClass]="{'verde':node.avance>(+this.sharedService.limiteAmbar),'ambar':(node.avance>(+this.sharedService.limiteRojo)&&node.avance<(+this.sharedService.limiteAmbar+1)),'rojo' :node.avance<(+this.sharedService.limiteRojo+1) }"></div>
        </div>
      </div>
    </div>
  </mat-tree-node>
</mat-tree>
